// extracted by mini-css-extract-plugin
module.exports = {"storeTitleMain":"CategoryHeader_storeTitleMain__n4jZ_","pb12":"CategoryHeader_pb12__60Fhe","loadMore":"CategoryHeader_loadMore__WO5P8"};